import React from 'react';
import { ContextMenuItem, useApi } from '@axiom/ui';
import type { Candidate, CandidateRedux } from '@axiom/validation';
import { UrlSlugsUtil } from '@axiom/utils';

import { TaxonomyApi } from '../../api/taxonomy-api';
import { AxiomForTalentUtil } from '../../utils/axiom-for-talent-util';

export type TalentOpenInAltProps = {
  candidate: CandidateRedux | Candidate;
};

export const TalentOpenInAlt = ({ candidate }: TalentOpenInAltProps) => {
  const [{ data: taxonomy }] = useApi(TaxonomyApi.readTaxonomy());

  return (
    <ContextMenuItem
      name="OPEN_IN_ALT"
      onClick={() => {
        AxiomForTalentUtil.openAltSpv(
          UrlSlugsUtil.generateCandidateSlug(candidate, taxonomy)
        );
      }}
    >
      Open in Axiom for Clients
    </ContextMenuItem>
  );
};
